export enum LogLevel {
  ERROR,
  WARN,
  INFO,
  DEBUG,
}
